import ReactMarkdown from 'react-markdown';
import getSafe from '../utils/getSafe';
import { Typography } from '@mui/material';

const NotesDisplay = ({ appConfig, insurerId }) => {

  const notes = getSafe(() => appConfig.content.specifics[insurerId].notes, '');

  return (
    <div>
      {
        notes &&
        <Typography sx={{ mt: 2, fontSize: 14 }}>
          <b>Notes:</b>
          <ReactMarkdown>{notes}</ReactMarkdown>
        </Typography>
      }
    </div>
  );
};

export default NotesDisplay;